ApiPromise = require 'network/api-promise'
Auth = require 'db/auth'
BoardOrgSelectPermLevelView = require 'views/board-menu/board-org-select-perm-level-view'
Confirm = require 'views/lib/confirm'
CreateOrgView = require 'views/organization/create-org-view'
ModelLoader = require 'db/model-loader'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
_ = require 'underscore'
getExperiment = require 'lib/experiments/simple-test'

module.exports = class BoardSelectOrganizationView extends View

  viewTitleKey: 'change organization'

  events:
    'click .js-submit': 'submit'
    'change .js-org': 'orgSelected'
    'click .js-new-org': 'newOrg'
    'click .js-upgrade-link': 'trackUpgradeClick'

  render: ->
    data = @model.toJSON { org: true }
    orgs = if @model.owned() then Auth.me().organizationList.models else []
    data.orgs = (org.toJSON() for org in orgs)
    data.hasOrgs = data.orgs.length != 0

    if data.idOrganization
      for org in data.orgs
        if org.id == data.idOrganization
          org.select = true

    data.isPrivate = @model.isPrivate()
    data.allowsSelfJoin = @model.allowsSelfJoin()
    if data.org
      data.upgradeUrl = "/#{data.org.name}/billing"

    @$el.html(
      templates.fill(
        'popover_change_board_org',
        data
      )
    )

    @updateOrgOptions()
    @

  showOrgBoardVisPerms: (organization, idOrganizationSource) ->
    PopOver.pushView
      view: new BoardOrgSelectPermLevelView({ @model, organization, idOrganizationSource, @modelCache })

  changeOrg: (idOrganizationTarget, idOrganizationSource) ->
    orgChanged = idOrganizationTarget != idOrganizationSource

    # We aren't subscribed to the boards or the orgs, so we manually update the
    # client-side boardLists
    if orgChanged && idOrganizationSource
      # We may not be able to load the source organization model
      @modelCache.get('Organization', idOrganizationSource)?.boardList.remove(@model)

    settings = {}

    if orgChanged
      settings.idOrganization = idOrganizationTarget

    if idOrganizationTarget
      # If we're switching to an organization, we might set additional org
      # friendly permissions.

      # We only show this checkbox if the board is currently private, so it's
      # only used to make a private -> org transition, and if it isn't checked
      # there isn't any change being made
      if @$('.js-make-org-visible').is(':checked')
        settings["prefs/permissionLevel"] = 'org'

      # We only display this checkbox if the org isn't currently org joinable
      # If it isn't checked then there's no change being made to the org
      if @$('.js-make-org-joinable').is(':checked')
        settings["prefs/selfJoin"] = true

    @model.update(settings)

    if orgChanged && idOrganizationTarget
      @modelCache.get('Organization', idOrganizationTarget).boardList.add(@model)

    PopOver.hide()

  newOrg: (e) ->
    track("Board Header", "Add to a Team menu", "New Org")
    Util.stop(e)

    createOpts = { boardToAddToOrg: @model }
    trackingOpts = { category: 'board', method: 'by clicking create team in board change team menu' }

    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache, createOpts, trackingOpts })

  canAddToOrg: (organizationTarget) ->
    organizationTarget.canAddBoard(@model)

  submit: (e) ->
    if @$('.js-submit').hasClass('disabled')
      Util.stop(e)
      return

    @$('.js-submit').prop('disabled', true).toggleClass('disabled', true)

    Util.stop(e)
    track("Board", "Change Org")
    idOrganizationTarget = @$('.js-org').val()
    idOrganizationSource = @model.get('idOrganization')
    organizationTarget = @modelCache.get('Organization', idOrganizationTarget)

    Promise.try =>
      targetIsMembersOnly =
        (organizationTarget && organizationTarget.externalMembersDisabled())

      if !targetIsMembersOnly
        return

      ModelLoader.loadOrganizationMembersData idOrganizationTarget
      .then =>
        externalMembers = @model.memberList.chain()
          .filter (member) -> !organizationTarget.isMember(member)
          .map (member) -> member.get('fullName')
          .value()

        count = externalMembers.length

        if count == 0
          return

        confirmKey =
          if count == 1
            'external member not allowed'
          else
            'external members not allowed'

        Promise.fromNode (next) =>
          Confirm.toggle confirmKey,
            elem: e.currentTarget
            model: @model
            confirmBtnClass: 'negate'
            templateData: {
              count: String(count)
              members:
                if externalMembers.length > 20
                  _.first(externalMembers, 20).join(', ') + '…'
                else
                  externalMembers.join(', ')
              team: organizationTarget.get('displayName')
            }
            fxConfirm: =>
              next()
            fxCancel: =>
              next(new Error('cancelled'))

    .then =>
      if organizationTarget?.isFeatureEnabled('restrictVis')
        ModelLoader.loadOrganizationMembersData idOrganizationTarget
        .then =>
          if @canAddToOrg(organizationTarget)
            @changeOrg(idOrganizationTarget, idOrganizationSource)
          else
            @showOrgBoardVisPerms(organizationTarget, idOrganizationSource)
          return
        .done()
      else
        @changeOrg(idOrganizationTarget, idOrganizationSource)
    .error(->)
    .done()

  allowBoardCreate: ->
    @$('.js-submit').removeClass('disabled')
    @$('.js-boards-limit-upgrade-ad').addClass('hide')
    @$('.js-permissions').removeClass('hide')

  updateOrgOptions: ->
    @$('.js-submit').addClass('disabled')
    orgId = @$('.js-org').val()
    hasOrgSelected = orgId != ''

    @$('.js-make-org-visible,.js-make-org-joinable')
    .closest('.js-check-div')
    .toggleClass('hide', !hasOrgSelected)

    if !hasOrgSelected
      @allowBoardCreate()
      return

    ApiPromise
      type: 'POST'
      url: "/1/organizations/#{orgId}/boardLimits"
    .then (boardLimitData) =>
      if boardLimitData.enabled
        trackUe('board limits', 'shows', 'upgrade ad', '', '', 'by selecting a team in add to a team', { teamId: orgId })
        @$('.js-boards-limit-upgrade-ad').removeClass('hide')
        @$('.js-permissions').addClass('hide')
        upgradeUrl = "/#{@modelCache.get('Organization', orgId).get('name')}/billing"
        @$('.js-upgrade-link').attr('href', upgradeUrl)
      else
        @allowBoardCreate()
    return

  orgSelected: (e) ->
    @updateOrgOptions()

  trackUpgradeClick: ->
    trackUe('board limits', 'clicks', 'upgrade button', 'add board upgrade ad', '', '', { teamId: @$('select.js-org').val() })



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-select-organization-view.coffee